import React, { ComponentClass, createElement } from 'react'
import { BottleneckMessage, bottleneckMessageHasRelatedCalls } from '../domain/BottleneckMessage'
import Percent from '../helper/percent'
import { FunctionCall } from '../helper/FunctionCall'
import Link from '../helper/link'
import { TimelineSpan } from '../domain/TimelineSpan'
import Milliseconds from '../helper/milliseconds'

interface Props {
    type: string
    message?: BottleneckMessage
    spans?: TimelineSpan[]
    routes?: {
        clickRoute: string
        callgraphRoute: string
        timelineRoute: string
    }
}

interface State {
    module?: ComponentClass
    moduleType?: string
}

export class BottleneckView extends React.PureComponent<Props, State> {
    state: State = {}

    constructor(props: Props) {
        super(props)

        this.assertTypeDoesNotTraverseUp(props.type)

        import(/* webpackMode: "eager" */ './bottlenecks/' + props.type).then(module =>
            this.setState({ module: module.default, moduleType: props.type }),
        )
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps.type !== this.props.type) {
            this.assertTypeDoesNotTraverseUp(this.props.type)

            import(/* webpackMode: "eager" */ './bottlenecks/' + this.props.type).then(module =>
                this.setState({ module: module.default, moduleType: this.props.type }),
            )
        }
    }

    public render() {
        const { message, type, spans, routes } = this.props

        if (!this.state.module || type !== this.state.moduleType) {
            return null
        }

        const relatedSpans: TimelineSpan[] = spans ? spans.filter(span => span.bottlenecks?.includes(type)) : []

        return (
            <>
                {message ? (
                    <h4 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>{message.label}</span>
                        <span className="label label-outline-default">
                            Estimated Impact: <Percent value={message.impact} />
                        </span>
                    </h4>
                ) : null}
                {// @ts-ignore
                createElement(this.state.module, { message, type })}
                {routes &&
                message?.args &&
                bottleneckMessageHasRelatedCalls(message.args) &&
                Object.keys(message.args.relatedCalls).length > 0 ? (
                    <>
                        <h4 className="tw-font-size-16 tw-mt-24">Related Calls</h4>
                        <table className="table table-striped table-bordered table-condensed">
                            <tbody>
                                {Object.entries(message.args.relatedCalls)
                                    .sort((a, b) => b[1] - a[1])
                                    .map(([call, totalTime]) => (
                                        <tr key={call}>
                                            <td>
                                                <Link route={routes.callgraphRoute} params={{ fn: call }}>
                                                    <div
                                                        style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}
                                                    >
                                                        <div>
                                                            <FunctionCall call={call} />
                                                        </div>
                                                        <div>
                                                            <Milliseconds value={totalTime} />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </>
                ) : null}
                {routes && relatedSpans.length > 0 ? (
                    <>
                        <h4 className="tw-font-size-16 tw-mt-24">Related Timeline Spans</h4>
                        <table className="table table-striped table-bordered table-condensed">
                            <tbody>
                                {relatedSpans
                                    .sort((a, b) => b.wt - a.wt)
                                    .map(span => (
                                        <tr key={span.id}>
                                            <td>
                                                <Link route={routes.timelineRoute} params={{ span: span.id }}>
                                                    <div
                                                        style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}
                                                    >
                                                        <div>{span.name}</div>
                                                        <div>
                                                            <Milliseconds value={span.wt} />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </>
                ) : null}
            </>
        )
    }

    assertTypeDoesNotTraverseUp = (type: string): void => {
        if (type.includes('..')) {
            throw new Error('Invalid type: "' + type + '", parent directory traversal is not allowed.')
        }
    }
}
